export default __webpack_public_path__ + "static/media/1748.387b3e09.png";